export const CLIENT_WORK_EXIT_EVENT = 'studio:client-work-exit'
export const CLIENT_WORK_EXIT_RESET_EVENT = 'studio:client-work-exit-reset'

const popGuards = new Set()
const navigatorGuards = new WeakMap()
const handlePop = (event) => { for (const guard of popGuards) guard(event) }
// At window's target phase listeners run in registration order. Subscribe
// before BrowserRouter mounts; otherwise it can unmount the composer and
// remove its guard before that guard sees a browser Back/Forward event.
if (typeof window !== 'undefined') window.addEventListener('popstate', handlePop, true)
if (import.meta.hot) import.meta.hot.dispose(() => window.removeEventListener('popstate', handlePop, true))

export function subscribeClientWorkPopGuard(guard) {
  popGuards.add(guard)
  return () => popGuards.delete(guard)
}

export function subscribeClientWorkNavigationGuard(navigator, confirm) {
  if (!navigator) return () => {}
  let entry = navigatorGuards.get(navigator)
  if (!entry) {
    entry = { guards: new Set(), originals: {}, wrappers: {} }
    navigatorGuards.set(navigator, entry)
    for (const method of ['push', 'replace', 'go']) {
      if (typeof navigator[method] !== 'function') continue
      entry.originals[method] = navigator[method]
      entry.wrappers[method] = (...args) => {
        for (const guard of entry.guards) if (!guard(method)) return
        return entry.originals[method].apply(navigator, args)
      }
      navigator[method] = entry.wrappers[method]
    }
  }
  entry.guards.add(confirm)
  return () => {
    entry.guards.delete(confirm)
    if (entry.guards.size) return
    for (const method of Object.keys(entry.originals)) {
      if (navigator[method] === entry.wrappers[method]) navigator[method] = entry.originals[method]
    }
    navigatorGuards.delete(navigator)
  }
}

// Scope/auth changes happen before the router navigates. Let the active work
// guard veto those changes before an upload loses its organization or session.
export function confirmClientWorkExit() {
  return window.dispatchEvent(new Event(CLIENT_WORK_EXIT_EVENT, { cancelable: true }))
}

export function resetClientWorkExit() {
  window.dispatchEvent(new Event(CLIENT_WORK_EXIT_RESET_EVENT))
}
